import * as React from "react";
import { Box, Stack } from "@mui/material";
import { colors } from "@/styles/constants";
import { Responsible } from "./Responsible";
import { FieldRow, FieldsTable } from "../../../../components/molecules/FieldsTable";
import { readableAccountNextSteps, readableAccountType } from "@/utils/accounts";
import { AccountDisplayInfo } from "./AccountDetails";

export const PensionAccount: React.FC<AccountDisplayInfo> = ({ persons, account, documents }) => {
  const {
    serviceProviderType,
    holderNumber,
    accountType,
    accountTypeOther,
    nextSteps,
    responsibleId,
  } = account;

  return (
    <FieldsTable>
      <FieldRow label="Customer reference" value={holderNumber} />

      <FieldRow label="Policy type" value={readableAccountType(accountType, accountTypeOther)} />

      <FieldRow
        label="Next step"
        value={readableAccountNextSteps(nextSteps, serviceProviderType)}
      />

      <FieldRow
        label="Responsible"
        value={<Responsible persons={persons} responsibleId={responsibleId} />}
      />

      {documents && documents.length > 0 && (
        <FieldRow
          label="Documents"
          value={
            <Stack>
              {documents.map((doc, index) => (
                <Box key={index}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={doc.downloadUrl}
                    style={{ color: colors.primary }}
                  >
                    {doc.filename}
                  </a>
                </Box>
              ))}
            </Stack>
          }
        />
      )}
    </FieldsTable>
  );
};
